<template>
    <v-modal ref="modal" @opened="modalOpened" >
        <slot slot="title">{{ $t('coupon.label.add_new_value') }}</slot>
        <slot slot="buttonContent">
            <v-block type="mini" height="stretch" color="white">
                <span class="u-flex-set">
                    <button class="c-button c-button--icon-only" type="button">
                        <svgicon name="added"></svgicon>
                    </button>
                </span>
            </v-block>
        </slot>
        <div class="o-wrapper o-wrapper--center">
            <form action="" class="c-form c-form--horizontal">
                <div class="u-max-700 c-form-row">
                    <v-form-row>
                        <v-custom-select v-model="SelectedCurrency"
                                         :options="currencyOptions"
                                         search-label="Code" 
                                         option-name="Code"
                                         option-value="Id"  
                                         track-by="Id"
                                         :fluid="true" 
                                         :multiple="false">
                            <slot slot="label">{{ $t('coupon.label.currency') }}</slot>
                        </v-custom-select>
                    </v-form-row>
                    <v-form-row>
                        <v-input v-model="CouponValue.Value" name="couponValue" type="number" :fluid="true">
                            <slot slot="label">{{ $t('coupon.label.amount') }}</slot>
                        </v-input>
                    </v-form-row>
                    <v-form-row>
                        <div class="c-form-item c-form-item--horizontal">
                            <v-label></v-label>
                            <button @click="addNewCouponValue" type="button" class="c-button c-button--alpha" :disabled="!canAdd">{{ $t('coupon.button.create') }}</button>
                        </div>
                    </v-form-row>
                </div>
            </form>
        </div>       
    </v-modal>
</template>

<script>
    import VModal from '@/components/modal/Modal'
    import VBlock from '@/components/blocks/Block'
    import VFormRow from '@/components/form/Row'
    import VInput from '@/components/form/Input'
    import VLabel from '@/components/form/Label'
    import VCustomSelect from '@/components/form/CustomSelect'

    // Store
    import {mapGetters} from 'vuex'

    export default {
        components: {
            VModal,
            VBlock,
            VFormRow,
            VInput,
            VLabel,
            VCustomSelect
        },
        data() {
            return {
                CouponValue: {
                    Id: "00000000-0000-0000-0000-000000000000",
                    Value: 0,
                    CouponId: this.couponId
                },
                SelectedCurrency: {}
            }
        },
        props: {
            couponId: String,
            currencyOptions: Array
        },
        computed: {
            canAdd(){
                return this.SelectedCurrency.Id && this.SelectedCurrency.Id > 0;
            }
        },
        watch:{
            SelectedCurrency(){
                if(this.canAdd === true) {
                    this.CouponValue.CurrencyId = this.SelectedCurrency.Id;
                }
            }
        },
        methods: {
            addNewCouponValue() {
                this.$emit('couponValueAdded', this.CouponValue);
                this.$refs.modal.closeDialog();        
            },
            modalOpened(){
                this.CouponValue = {
                    Id: "00000000-0000-0000-0000-000000000000",
                    Value: 0,
                    CouponId: this.couponId
                };
                this.SelectedCurrency = {}
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";
</style>


// WEBPACK FOOTER //
// src/components/coupons/AddCouponValue.vue